import { FC } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import routes from 'global/Constants/routes';

const HasNoBankAccount: FC = () => {
  //hooks
  const { push } = useHistory();

  return (
    <div className='mb-2 animate-pulse' onClick={() => push(routes.personBankAccount.path + '?hasAnyAccount=' + false)}>
      <div className='px-10 py-2 transition-shadow duration-300 rounded-lg shadow cursor-pointer bg-t-error-color text-t-opposite-text-color inherit-color hover:shadow-lg'>
        <span className='block text-sm font-medium'>
          <InfoCircleOutlined className='ml-2' />
          حساب بانکی تعریف نشده
        </span>
        <span className='block text-xs text-center text-t-secondary-text-color'>برای ثبت حساب کلیک کنید</span>
      </div>
    </div>
  );
};

export default HasNoBankAccount;
